var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.types),function(type){return [(_vm.precise[type])?_c('span',{key:type},[_vm._v(" "+_vm._s(_vm.precise[type])+" "+_vm._s(_vm._f("timeLabel")(type,_vm.precise[type]))+_vm._s(_vm.getSpacer(type))+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }